<h2>{{ data().title | translate }}</h2>
